import styled from '@emotion/styled'
import { CustomerReviews } from 'app/components/CustomerReviews'
import { Hero } from 'app/components/Hero'
import { Intro } from 'app/components/Intro'
import { RoomsList } from 'app/components/RoomsList'
import { RoomsNavigation } from 'app/components/RoomsNavigation'
import { SEO } from 'app/components/SEO'
import { ServicesList } from 'app/components/ServicesList'
import { Social } from 'app/components/Social'
import { Footer } from 'app/containers/Footer'
import { GoogleAnalytics } from 'app/containers/GoogleAnalytics'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { StructuredData } from 'app/containers/StructuredData'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id?: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function RoomsPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Container>
      <SEO {...context.seoProps} />
      <GoogleAnalytics />
      {pageContext.headerProps ? (
        <Header
          pageID={pageContext.id}
          languageCode={pageContext.languageCode}
          languagePrefix={pageContext.languagePrefix}
          {...pageContext.headerProps}
        />
      ) : null}
      {context.heroProps ? <Hero {...context.heroProps} /> : null}
      {context.roomsNavigationProps ? (
        <RoomsNavigation {...context.roomsNavigationProps} />
      ) : null}
      {context.introProps ? <Intro {...context.introProps} /> : null}
      {context.servicesListProps ? (
        <ServicesList {...context.servicesListProps} />
      ) : null}
      {context.roomsListProps ? (
        <RoomsList {...context.roomsListProps} />
      ) : null}
      {context.customerReviewsProps ? (
        <CustomerReviews {...context.customerReviewsProps} />
      ) : null}
      {context.socialProps ? <Social {...context.socialProps} /> : null}
      <Footer
        languageCode={pageContext.languageCode}
        languagePrefix={pageContext.languagePrefix}
      />
      <StructuredData languageCode={pageContext.languageCode} />
    </Container>
  )
})

const Container = styled.main``
